var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('restore.title')))])]),_vm._v(" "),_c('v-card-text',[_c('mnemonic',{on:{"mnemonic":_vm.restore}})],1),_vm._v(" "),_c('password',{attrs:{"open":_vm.passwordRequired},on:{"password":_vm.setPassword}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68ef0d4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/controllers/Restore.vue
// module id = pv4d
// module chunks = 1